import { Modal, ModalContent } from "@bokio/designsystem/components/Modal";
import { SignUpLangFactory } from "@bokio/lang";
import * as m from "@bokio/mobile-web-shared/core/model/model";

import { BankIdSecureStart } from "../BankIdSecureStart/BankIdSecureStart";

import BankIdCollectionStatus = m.Bokio.Common.Contract.BankId.BankIdCollectionStatus;
import BankIdHintCode = m.Bokio.Common.Contract.BankId.BankIdHintCode;

type BokioPayBankIdAuthModalProps = {
	autoStartToken?: string;
	qrStartToken?: string;
	qrCode?: string;
	collectionStatus?: BankIdCollectionStatus;
	hintCode?: BankIdHintCode;
	isPolling: boolean;

	onClose: () => void;

	onStartPollingQrCode: () => void;
	onStopPollingQrCode: () => void;
	onBankIdOpen?: () => void;
};

export function BokioPayBankIdAuthModal(props: BokioPayBankIdAuthModalProps) {
	const signupLang = SignUpLangFactory();

	const shouldShowBankIdModal = !!(
		props.isPolling ||
		(props.autoStartToken && props.qrStartToken) ||
		props.collectionStatus === BankIdCollectionStatus.Failed
	);

	return (
		<Modal
			visible={shouldShowBankIdModal}
			title={signupLang.Login_LoginWithBankId}
			onClose={props.onClose}
			disableBackgroundClick={true}
		>
			<ModalContent>
				<BankIdSecureStart
					isBokioPayLogin
					autoStartToken={props.autoStartToken}
					bankIdQrCode={props.qrCode}
					hintCode={props.hintCode}
					collectionStatus={props.collectionStatus}
					onStartPollingQrCode={props.onStartPollingQrCode}
					onStopPollingQrCode={props.onStopPollingQrCode}
					onBankIdOpen={props.onBankIdOpen}
				/>
			</ModalContent>
		</Modal>
	);
}
